export default __webpack_public_path__ + "static/media/annie-spratt-dWYU3i-mqEo-unsplash.871ceea0.jpg";